import { store } from "../redux/store";
import { StoreState } from "../redux/storeSlice";

export const getStoreId = (): number => {
  const state: { store: StoreState } = store.getState();
  return state.store.store.id;
};



